import { FC, memo } from 'react'

import { useAssignment } from '@pepper/ui'

interface Props {
  assignmentId: string
  updateData: (val: Assignment) => void
  updateError: (val: boolean) => void
}

const AssignmentData: FC<Props> = ({
  assignmentId,
  updateData,
  updateError,
}) => {
  const { data: assignment, error } = useAssignment({
    assignmentId: assignmentId,
  })
  error && updateError(true)
  assignment && updateData(assignment)
  return null
}
export default memo(AssignmentData)
